
























































































import {Vue, Component, PropSync} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {XiaomiType} from "@/store/push/application/types";
import {isEmpty} from "lodash";

@Component({
  components: {proxySettingsForm}
})
export default class XiaomiSettings extends Vue {
  @PropSync('xiaomiOptions') xiaomi!: XiaomiType;

  get isXiaomiProxy(): boolean {
    return !isEmpty(this.xiaomi.proxy_settings);
  }

  set isXiaomiProxy(value: boolean) {
    if (value) {
      this.$set(this.xiaomi, 'proxy_settings', { host: null });
    } else {
      this.$delete(this.xiaomi, 'proxy_settings');
    }
  }
}
